import React, { useEffect, useState } from "react";
import { apiRequest } from "../apiService/allapi";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function AllAchivers() {
  const [allAchivers, setAllAchivers] = useState([]);
function NextArrow({ onClick }) {
  return (
    <button className="custom-next" onClick={onClick}>
      ❯
    </button>
  );
}

function PrevArrow({ onClick }) {
  return (
    <button className="custom-prev" onClick={onClick}>
      ❮
    </button>
  );
}
  const getAllAchivers = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await apiRequest("/Achivers/getPoolAchivers", "GET", null, {
        Authorization: `Bearer ${token}`,
      });

      if (res?.data?.status === "success") {
        setAllAchivers(res.data.data);
      }
    } catch (error) {
      console.log("Achivers API Error:", error);
    }
  };

  useEffect(() => {
    getAllAchivers();
  }, []);
const settings = {
  dots: false,
  infinite: allAchivers.length > 4,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

  return (
    <div className="container py-4">
      <div class="section-title">
        <h5>All Achievers</h5>

        <div class="section-borders">
          <span></span>
          <span class="black-border"></span>
          <span></span>
        </div>
      </div>
     <div className="all-achievers-slider position-relative">
  <Slider
    {...settings}
    style={{
      height: "210px",
    }}
  >
    {allAchivers.map((item, index) => (
      <div key={index} className="px-2 mt-4 achiver-div">
        <div
          className="card border-0"
          style={{ background: "#f8eae4" }}
        >
          <div className="card-body text-center">
            <img
              src={`${process.env.REACT_APP_IMAGE_BASE_URL}${item.imageUrl}`}
              alt={item.memberName}
              className="rounded-circle mb-3"
              width="90px"
              height="90px"
              style={{
                objectFit: "cover",
                border: "1px solid #ff6b00",
                background: "#fff",
                width: "80px",
                height: "80px",
                margin: "auto",
              }}
            />

            <h6 style={{ margin: "10px 0" }}>
              {item.memberName}
            </h6>

            <p className="mb-1">
              {item.memberId} ({item.poolName})
            </p>
          </div>
        </div>
      </div>
    ))}
  </Slider>
</div>
    </div>
  );
}

export default AllAchivers;
